<template>
  <div>
    <PageTitle
      title="Products"
      :btnCreate="true"
      :createRoute="'/product/add'"
      :permission="'Product Create'"
    />
    <v-container
      fluid
      class="lighten-12 content"
      style="background-color: white"
    >
      <v-flex>
        <v-row v-if="false">
          <!-- Product info box -->
          <v-col
            class="pr-1 text-left"
            cols="12"
            xs="12"
            sm="12"
            md="4"
            lg="4"
            xl="4"
            v-for="i in [
              'linear-gradient(to right, #00c5fb 0%, #0253cc 100%)',
              'linear-gradient(to right, rgb(0 226 9) 0%, rgb(76 175 80) 100%)',
              'linear-gradient(to right, #be64e2 0%, #851298 100%)',
            ]"
            :key="i"
          >
            <v-card class="mx-auto" :color="i" :style="'background:' + i">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="headline mb-1 white--text"
                    >Nestomalt</v-list-item-title
                  >
                  <v-list-item-subtitle class="white--text"
                    >Product Growth by 6%</v-list-item-subtitle
                  >
                </v-list-item-content>

                <v-icon medium color="white">mdi-trending-up</v-icon>
              </v-list-item>
            </v-card>
          </v-col>
        </v-row>
      </v-flex>
      <!-- <hr style="border-top: 1px dashed rgb(173 173 173)" /> -->
      <v-btn :ripple="false" class="min-button" icon @click="show = !show">
        <v-icon color="blue" class="ml-12">
          {{ show ? 'mdi-filter' : 'mdi-filter-outline' }}
        </v-icon>
        <span class="subheading filterclor">Filter</span>
      </v-btn>
      <v-expand-transition>
        <v-card class="lighten-12 card-content" v-show="show">
          <TableFilters
            :filters="['brand', 'supplier', 'category', 'status', 'search']"
            v-model="filter"
            :msgs="'Name/Code'"
            :columns="columns"
          ></TableFilters>
        </v-card>
      </v-expand-transition>

      <v-card class="mt-2">
        <v-container fluid>
          <v-row>
            <v-col cols="1"></v-col>
            <v-col cols="1" style="padding: 0" v-if="BulkEdit.length > 1">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="my-1"
                    fab
                    v-on="on"
                    :disabled="updatebutton"
                    dark
                    small
                    @click="clearAllBulkEdit"
                    style="background: rgb(202 37 37); color: white"
                  >
                    <v-icon style="color: white" dark> mdi-reload </v-icon>
                  </v-btn>
                </template>
                <span>Clear All</span>
              </v-tooltip>
            </v-col>
            <v-col cols="1" style="padding: 0" v-if="BulkEdit.length">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="my-1 ml-4"
                    fab
                    v-on="on"
                    :disabled="updatebutton"
                    dark
                    small
                    @click="UpdateBulkData"
                    color="indigo"
                  >
                    <v-icon style="color: white" dark>
                      mdi-checkbox-multiple-marked-circle
                    </v-icon>
                  </v-btn>
                </template>
                <span>Update All</span>
              </v-tooltip>
            </v-col>

            <v-card-text class="pa-0">
              <v-data-table
                v-model="selected"
                @item-selected="bulkSelect"
                @toggle-select-all="bulkdatas"
                :items-per-page="paginationOptions.perPage"
                :fixed-header="true"
                :headers="headers"
                :items="products"
                item-key="id"
                hide-default-footer
                class="row-pointer product-list"
                show-select
                style="
                  font-weight: normal;
                  font-family: 'Source Sans Pro', sans-serif;
                "
                @click:row="
                  isSelected(item)
                    ? null
                    : $router.push(`/product/${$event.id}`)
                "
              >
                <template v-slot:no-data>
                  <noData
                    class="mt-16 container justify-center item-center"
                    name="product"
                  />
                </template>
                <template v-slot:item.code="{ item }">
                  <div>
                    <v-text-field
                      v-if="isSelected(item)"
                      :value="item.code"
                      :error-messages="errors"
                      @change="updateProductCode($event, item)"
                      outlined
                      dense
                      hide-details="auto"
                      label="Code"
                      required
                    ></v-text-field>
                    <div v-else class="tbl-data">
                      {{ item.code }}
                    </div>
                  </div>
                  <div
                    style="color: red; font-size: 10px"
                    v-if="isSelected(item) && item.alreadyCode"
                  >
                    This code already used
                  </div>
                </template>
                <template v-slot:item.name="{ item }" v-if="RowVisible">
                  <div>
                    <v-text-field
                      v-if="isSelected(item)"
                      :value="item.name"
                      :error-messages="errors"
                      @change="updateProductName($event, item)"
                      outlined
                      dense
                      hide-details="auto"
                      label="Name"
                      required
                    ></v-text-field>

                    <div v-else class="tbl-data product-name">
                      <v-tooltip top color="primary">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            color="grey lighten-1"
                            small
                            dark
                            v-bind="attrs"
                            v-on="on"
                            @mouseenter="productnameFind(item)"
                            >mdi-information</v-icon
                          >
                        </template>
                        <span>{{ productname }}</span>
                      </v-tooltip>
                      {{ item.name ? item.name : '---------' }}
                    </div>
                  </div>

                  <div
                    style="color: red; font-size: 10px"
                    v-if="isSelected(item) && item.alreadyName"
                  >
                    This Name Already used
                  </div>
                </template>
                <template v-slot:item.min_price="{ item }">
                  <div>
                    <v-text-field
                      v-if="isSelected(item)"
                      :value="item.min_price"
                      :error-messages="errors"
                      @change="updateProductMinPrice($event, item)"
                      outlined
                      dense
                      hide-details="auto"
                      label="Minimum Price"
                      required
                    ></v-text-field>
                    <div v-else class="tbl-data">
                      {{ item.min_price }}
                    </div>
                  </div>
                </template>
                <!-- No -->
                <template v-slot:item.no>
                  <v-icon>mdi-vuetify</v-icon>
                </template>

                <!-- Image -->
                <template v-slot:item.image="{ item }">
                  {{ selected.id }}
                  <img
                    v-if="item.image"
                    :src="item.image"
                    height="25"
                    width="25"
                    class="image"
                  />
                  <v-avatar v-else size="25px" item color="primary">
                    <span class="white--text subtitle-3 text-uppercase">
                      {{ item.name.substring(0, 2) }}</span
                    >
                  </v-avatar>
                </template>

                <!-- Category -->
                <template v-slot:item.category="{ item }">
                  <div class="tbl-data">
                    {{ item.category.name ? item.category.name : '---------' }}
                  </div>
                </template>

                <!-- Brand -->
                <template v-slot:item.brand="{ item }">
                  <div class="tbl-data">
                    {{ item.brand.name ? item.brand.name : '---------' }}
                  </div>
                </template>

                <!-- Status -->
                <template v-slot:item.status="{ item }">
                  <v-chip
                    :x-small="true"
                    class="ma-2 cursor-pointer tbl-data"
                    label
                    text-color="white"
                    :color="getStatusColor(item.is_active)"
                    dark
                    style="
                      color: white;
                      font-variant-caps: all-small-caps;
                      font-weight: bold;
                    "
                    >{{ item.is_active ? 'Active' : 'Archived' }}</v-chip
                  >
                </template>

                <!-- Action -->
                <template v-slot:item.action="{ item }">
                  <list-menu
                    feature="product"
                    :item="item"
                    viewPermission="Product Show"
                    editPermission="Product Edit"
                    softDeletePermission="Product Soft Delete"
                    @refreshList="refreshData"
                  ></list-menu>
                </template>

                <template v-slot:footer>
                  <pagination
                    @paginationOptions="setPaginationOptions"
                    @response="setResponseData"
                    @getPageNumber="setPagenumber"
                    url="products"
                    :filterAction="true"
                    :filter="filter"
                    ref="pagination"
                  />
                </template>
              </v-data-table>
            </v-card-text>
          </v-row>
        </v-container>
      </v-card>

      <div class="d-flex justify-center align-center"></div>
      <!-- </v-row> -->
    </v-container>
  </div>
</template>

<script>
// Components
import PageTitle from '@/components/shared/PageTitle';
import pagination from '../../shared/components/pagination';
import confirmation from '../../shared/components/confirmation';
import TableFilters from '@/components/base/TableFilters';
import axios from '@/plugins/axios';
import noData from '../../../components/shared/noItem';
import { required, email, max } from 'vee-validate/dist/rules';
import { mapGetters } from 'vuex';
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from 'vee-validate';
import BrandAutoComplete from '@/components/base/BrandAutoComplete';
import CategoryAutoComplete from '@/components/base/CategoryAutoComplete';
import StatusAutoComplete from '@/components/base/StatusAutoComplete';
import _ from 'lodash';
import { mapState } from 'vuex';

extend('required', {
  ...required,
  message: '{_field_} is required',
});

extend('max', {
  ...max,
  message: '{_field_} may not be greater than {length} characters',
});

extend('email', {
  ...email,
  message: 'Email must be valid',
});

export default {
  data: () => ({
    show: false,
    productname: '',
    paginationOptions: {},
    selected: [],
    updatebutton: false,

    columns: [
      {
        text: 'Image',
        value: 'image',
        show: true,
        disabled: true,
        width: '14%',
        align: 'center',
        sortable: false,
      },
      {
        text: 'Name',
        value: 'name',
        show: true,
        disabled: true,
        width: '14%',
        sortable: false,
      },
      {
        text: 'Code',
        value: 'code',
        show: true,
        disabled: false,
        width: '14%',
        sortable: false,
      },
      {
        text: 'Minimum Price',
        value: 'min_price',
        show: true,
        disabled: false,
        width: '14%',
        sortable: false,
        align: 'right',
      },
      {
        text: 'Category',
        value: 'category',
        show: true,
        disabled: false,
        width: '14%',
        sortable: false,
      },
      {
        text: 'Brand',
        value: 'brand',
        show: true,
        disabled: false,
        width: '14%',
        sortable: false,
      },
      {
        text: 'Status',
        value: 'status',
        show: true,
        disabled: false,
        align: 'center',
        width: '10%',
        sortable: false,
      },
      {
        text: 'Actions',
        value: 'action',
        show: true,
        disabled: false,
        align: 'center',
        width: '14%',
        sortable: false,
      },
    ],
    products: [],
    RowVisible: true,
    RowVisibleCode: true,
    RowVisibleMinPrice: true,
    // Filters
    filter: {
      category: '',
      search: '',
      brand: '',
      status: '',
      supplier: '',
    },
  }),
  components: {
    PageTitle,
    ValidationProvider,
    ValidationObserver,
    pagination,
    TableFilters,
    noData,
  },
  created() {
    this.updateSelectedValues();
  },
  mounted() {
    // this.Allselecteditems();
  },
  methods: {
    productnameFind(item) {
      this.productname = item.name;
    },
    updateSelectedValues() {
      this.selected = this.SelectedDatas;
    },
    bulkdatas(data) {
      this.$store.commit('CLEAR_ALL', {});
      this.$store.commit('CLEAR_ALL_ROWS', {});
      if (data.value) {
        data.items.map((h) => {
          this.$store.commit('UPDATE_PRODUCTBULK', {
            id: h.id,
            code: h.code,
            name: h.name,
            min_price: parseFloat(h.min_price),
          });
          this.$store.commit('UPDATE_SELECTEDROWS', h);
        });
      }
    },
    bulkSelect(data) {
      if (this.isAlreadySelected(data.item)) {
        let findvalue = _.findIndex(
          this.BulkEdit,
          (e) => {
            return e.id == data.item.id;
          },
          0,
        );
        this.$store.commit('REMOVE_PRODUCTBULK', {
          index: findvalue,
        });
      } else {
        this.$store.commit('UPDATE_PRODUCTBULK', {
          id: data.item.id,
          name: data.item.name,
          code: data.item.code,
          min_price: parseFloat(data.item.min_price),
        });
      }
      if (this.isAlreadySelectedRows(data.item)) {
        let findvalueindex = _.findIndex(
          this.SelectedDatas,
          (e) => {
            return e.id == data.item.id;
          },
          0,
        );
        this.$store.commit('REMOVE_SELECTEDDATA', {
          index: findvalueindex,
        });
      } else {
        this.$store.commit('UPDATE_SELECTEDROWS', data.item);
      }
    },
    isSelected(data) {
      const result = this.selected.filter((item) => item.id == data.id);
      return result.length != 0;
    },
    // Allselecteditems() {
    //  if(this.selected){
    //
    //   }
    // },
    isAlreadySelected(data) {
      const result = this.BulkEdit.filter((item) => item.id == data.id);
      return result.length != 0;
    },
    isAlreadySelectedRows(data) {
      const result = this.SelectedDatas.filter((item) => item.id == data.id);
      return result.length != 0;
    },
    isAlreadyHaveName(data) {
      const result = this.BulkEdit.filter((item) => item.name == data);
      return result.length != 0;
    },
    isAlreadyHaveCODE(data) {
      const result = this.BulkEdit.filter((item) => item.code == data);
      return result.length != 0;
    },
    isAlreadyHaveMinPrice(data) {
      const result = this.BulkEdit.filter((item) => item.min_price == data);
      return result.length != 0;
    },

    updateProductCode(newValue, item) {
      // Using lodash.findIndex
      let index = _.findIndex(
        this.BulkEdit,
        (e) => {
          return e.id == item.id;
        },
        0,
      );

      if (this.isAlreadyHaveCODE(newValue)) {
        this.RowVisibleCode = false;
        item.alreadyCode = true;
        item.code = newValue;
        setTimeout(() => {
          this.RowVisibleCode = true;
        }, 100);
      } else {
        this.RowVisibleCode = false;
        item.alreadyCode = false;
        item.code = newValue;
        setTimeout(() => {
          this.RowVisibleCode = true;
        }, 100);
        this.$store.commit('UPDATE_PRODUCT_CODE', {
          code: newValue,
          name: item.name,
          min_price: parseFloat(item.min_price),
          id: item.id,
          index: index,
        });
      }
    },
    updateProductMinPrice(newValue, item) {
      // Using lodash.findIndex
      let index = _.findIndex(
        this.BulkEdit,
        (e) => {
          return e.id == item.id;
        },
        0,
      );
      this.RowVisibleMinPrice = false;
      item.alreadyPrice = false;
      item.min_price = newValue;
      setTimeout(() => {
        this.RowVisibleMinPrice = true;
      }, 100);
      this.$store.commit('UPDATE_PRODUCT_MIN_PRICE', {
        min_price: newValue,
        code: item.code,
        name: item.name,
        id: item.id,
        index: index,
      });
    },
    updateProductName(newValue, item) {
      // Using lodash.findIndex

      let index = _.findIndex(
        this.BulkEdit,
        (e) => {
          return e.id == item.id;
        },
        0,
      );

      if (this.isAlreadyHaveName(newValue)) {
        this.RowVisible = false;
        item.alreadyName = true;
        item.name = newValue;
        setTimeout(() => {
          this.RowVisible = true;
        }, 100);
      } else {
        this.RowVisible = false;
        item.alreadyName = false;
        item.name = newValue;
        setTimeout(() => {
          this.RowVisible = true;
        }, 100);
        this.$store.commit('UPDATE_PRODUCT_NAME', {
          name: newValue,
          id: item.id,
          code: item.code,
          min_price: parseFloat(item.min_price),
          index: index,
        });
      }
    },
    setPaginationOptions(data) {
      this.paginationOptions = data;
    },
    setPagenumber(event) {
      this.$router.push('?page=' + event);
      this.$store.dispatch('SetProductSize', event);
    },
    refreshData() {
      this.$refs.pagination.refreshData();
    },
    clearAllBulkEdit() {
      this.$store.commit('CLEAR_ALL', {});
      this.$store.commit('CLEAR_ALL_ROWS', {});
      this.selected = [];
    },
    UpdateBulkData() {
      this.updatebutton = true;
      axios
        .patch('products/bulk-update', this.BulkEdit)
        .then((res) => {
          this.$toast.success('Products updated successfully');
          this.selected = [];
          this.updatebutton = false;
          this.$store.commit('CLEAR_ALL', {});
          this.$store.commit('CLEAR_ALL_ROWS', {});
          this.refreshData();
        })
        .catch((err) => {
          this.updatebutton = false;

          this.$toast.error('Failed to update product.');
        });
    },

    setResponseData(productData) {
      this.products = productData;
      this.products.map((u) => {
        if (u.image) {
          u.image = u.image + '?t=' + new Date().getTime();
        }
        u.alreadyName = false;
        u.alreadyCode = false;
        u.alreadyPrice = false;
      });
    },
    clearFilter() {
      this.filter = {};
    },
    getStatusColor(is_active) {
      return is_active ? 'green' : 'gray';
    },

    EditModal(item) {
      this.$router.push({ path: '/product/edit/' + item.id });
    },
  },
  computed: {
    ...mapGetters('product', ['GetAllProducts']),
    ...mapState(['BulkEdit']),
    ...mapState(['SelectedDatas']),

    // Filter - return selected table fields
    headers: function () {
      return this.columns.filter((item) => item.show == true);
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro&display=swap');
.tbl-data {
  /* font-weight: bold; */
}
.product-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 150px;
}
.filterclor {
  color: cornflowerblue;
  font-size: larger;
  font-weight: bold;
}

.min-button::before {
  display: none;
}
</style>
